/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloFlujos from 'Infotrack@Modelos/smartStock/flujos';
import IFlujos from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IFlujo';
import IFlujoEtapaDocumento from 'Infotrack@Modelos/smartStock/flujoEtapaDocumento/entidades/flujoEtapaDocumento';

export default class ControladorModeloFlujos {
    private modeloFlujos: ModeloFlujos;
    constructor() {
        this.modeloFlujos = new ModeloFlujos();
    }

    public consultarFlujos() {
        return this.modeloFlujos.consultarFlujos().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearFlujos(flujos: IFlujos) {
        const respuesta = this.modeloFlujos.crearFlujos(flujos);
        return (await respuesta).data.Entidades;
    }

    public async consultarFlujosPorFiltro(empresaId: string, estado?: number) {
        return this.modeloFlujos.consultarFlujosPorFiltro({ EmpresaId: empresaId, Estado: estado }).then(({ data: { Entidades } }) => Entidades);
    }

    public async editarFlujos(flujos: IFlujos) {
        const respuesta = this.modeloFlujos.editarFlujos(flujos);
        return (await respuesta).data.Entidades;
    }

    public async eliminarFlujos(flujos: IFlujos) {
        await this.modeloFlujos.eliminarFlujos(flujos);
    }

    public validarEntidad(flujos: IFlujos): boolean {
        if (flujos.FlujoDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public validarEntidadCreacionCompuesta(flujos: IFlujos,flujoEtapa: IFlujoEtapaDocumento): boolean {
        if (flujos.FlujoDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
